import React from "react"

import iconListCheckImg from "@shared/assets/images/icon-list-check.png"
import iconListImg from "@shared/assets/images/icon-list.png"

import { useSchedule } from "../../../../../@shared/contexts"
import { useChartStockCode } from "../../../../../@shared/stores/chartStore"
import {
  usePartenerTradeStrategy,
  usePartnerStockItemSeq,
} from "../../../../../@shared/stores/partnerStore"
import useCustomSearchParams from "../../../../../chart/hooks/useCustomSearchParams"
import {
  ContentType,
  useSetContentType,
  useSetIsMiniPlayerEnabled,
} from "../../../../contexts/miniPlayer"

const TradeItem = ({
  name,
  price,
  isNew,
  code,
  itemSeq,
  chgType,
  losscutPrice,
}: {
  name: string
  price: number | string
  isNew?: boolean
  code: string
  itemSeq?: string
  chgType?: "+" | "-"|""
  losscutPrice: string | number
}) => {
  const handleMiniPlayer = useSetIsMiniPlayerEnabled()
  const { setContentType } = useSetContentType()
  const { setParams } = useCustomSearchParams()
  const { setStockCode, setStockCodeAndPrice } = useChartStockCode()
  const { schedule } = useSchedule()
  const isPaidSchedule =
    !!schedule?.paymentInformation && schedule.paymentInformation === "PAID"
  const { setItemSeq } = usePartnerStockItemSeq()
  const { isOpenTradeStrategy, strategyItemSeq, setTradeStrategy } =
    usePartenerTradeStrategy()

  const handleClickStock = () => {
    if (!isPaidSchedule) {
      handleMiniPlayer.inactive()
      return
    }
    // 1. 차트 코드 갱신
    setParams("code", code)
    // TODO
    // setStockCode(code)
    setStockCodeAndPrice({ code, price: losscutPrice as number })

    setItemSeq(itemSeq)

    handleMiniPlayer.active()
    setContentType(ContentType.chart)

    // 2. 종목 전략 갱신 (종목 전략도 차트 선택에 따라 같이 변동)
    setTradeStrategy(isOpenTradeStrategy, itemSeq)
  }

  const handleClickSetTradeStrategy = () => {
    // 1. 종목 전략 갱신
    if (isOpenTradeStrategy && strategyItemSeq === itemSeq) {
      setTradeStrategy(false, null)
      return
    }
    setTradeStrategy(true, itemSeq)

    // 2. 차트 부분 갱신 (종목 전략 연동 기능으로 인해 추가)
    if (!isPaidSchedule) {
      handleMiniPlayer.inactive()
      return
    }
    setParams("code", code)
    // TODO
    // setStockCode(code)
    setStockCodeAndPrice({ code, price: losscutPrice as number })

    setItemSeq(itemSeq)

    handleMiniPlayer.active()
    setContentType(ContentType.chart)
  }

  return (
    <div className="tradeItem">
      <div className="stockName" onClick={handleClickStock}>
        {name}
      </div>
      <div
        className={`stockPrice ${
          chgType === "+" ? "up" : chgType === "-" ? "down" : ""
        }`}
        onClick={handleClickStock}
      >
        {price}
      </div>
      <div className="stockButton" onClick={handleClickSetTradeStrategy}>
        <img
          src={isNew ? iconListCheckImg : iconListImg}
          style={{ width: "30px" }}
          alt="stock"
        />
      </div>
    </div>
  )
}

export default TradeItem
